import api, { type StartAssessmentResponse } from 'api';

const assessmentStartRequests = new Map<number, Promise<StartAssessmentResponse | null>>();

const isValidUserId = (userId: number): boolean => Number.isFinite(userId) && userId > 0;

/**
 * Records assessment entry once per candidate for the current browser session.
 * The shared promise also prevents duplicate POSTs from React Strict Mode.
 */
export function startAssessmentOnce(
    userId: number,
    startedAt: Date = new Date()
): Promise<StartAssessmentResponse | null> {
    if (!isValidUserId(userId)) {
        return Promise.resolve(null);
    }

    const existingRequest = assessmentStartRequests.get(userId);
    if (existingRequest) {
        return existingRequest;
    }

    const request = api.tableInput
        .saveAssessmentStarted(userId, startedAt.toISOString())
        .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
                console.error(`Failed to start assessment: unexpected status ${response.status}`);
                return null;
            }
            return response.data;
        })
        .catch((error) => {
            console.error('Failed to start assessment', error);
            return null;
        });

    assessmentStartRequests.set(userId, request);
    return request;
}
